import { createReducer } from './utils'

export default createReducer({
    SITE_LOADING: (state, action) => {
        loading: action.loading || false
    }
})




// WEBPACK FOOTER //
// ./src/reducers/site.jsx